/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Needs_ReviewInputs */

const en_mobile_scan_needs_review = /** @type {(inputs: Mobile_Scan_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review page`)
};

const es_mobile_scan_needs_review = /** @type {(inputs: Mobile_Scan_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar página`)
};

/**
* | output |
* | --- |
* | "Review page" |
*
* @param {Mobile_Scan_Needs_ReviewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_needs_review = /** @type {((inputs?: Mobile_Scan_Needs_ReviewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Needs_ReviewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_needs_review(inputs)
	return en_mobile_scan_needs_review(inputs)
});